import { ModeledSavingsSlideOut } from '@/components/ModeledSavingsSlideOut';

import { useState } from 'react';

import { formatCurrency } from '@shared/formatCurrency';

interface QuoteDiscountSavingsDisplayProps {
  discountSavings?: number;
  discountPolicyType?: number;
  policyType?: number;
  className?: string;
  carrierName?: string;
  annualHealthcareInflationRate?: number;
}

export function QuoteDiscountSavingsDisplay({
  discountSavings,
  discountPolicyType,
  policyType,
  className = '',
  carrierName,
  annualHealthcareInflationRate,
}: QuoteDiscountSavingsDisplayProps) {
  const [isSlideOutOpen, setIsSlideOutOpen] = useState(false);

  const shouldShowSavings =
    discountSavings !== undefined &&
    discountSavings > 0 &&
    discountPolicyType !== undefined &&
    policyType !== undefined &&
    discountPolicyType === policyType;

  if (!shouldShowSavings) {
    return null;
  }

  const handleSavingsClick = () => {
    setIsSlideOutOpen(true);
  };

  return (
    <div className={`flex flex-col gap-1 ${className}`}>
      <div className="text-muted-foreground text-xs font-medium">Modeled Savings</div>
      <button
        type="button"
        onClick={event => {
          event.stopPropagation();
          handleSavingsClick();
        }}
        className="text-primary-dark hover:text-primary-dark/80 flex cursor-pointer items-center gap-1 text-sm font-semibold underline decoration-dotted decoration-1 underline-offset-2 transition-colors sm:text-base"
      >
        {formatCurrency(discountSavings)}
      </button>

      <ModeledSavingsSlideOut
        open={isSlideOutOpen}
        onClose={() => setIsSlideOutOpen(false)}
        carrierName={carrierName}
        annualHealthcareInflationRate={annualHealthcareInflationRate}
      />
    </div>
  );
}
